






import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet-easybutton';
import { MarkerClusterGroup } from 'leaflet';
import { AddressMarker, MarkerResult } from '../interfaces/markers';

@Component({
})
export default class Map extends Vue {
  map!: L.Map;

  addressMarkers: AddressMarker[] = [];

  addressClusters: { [key: string]: MarkerClusterGroup } = {};

  circle: L.Circle | null = null;

  readonly apiKey = 'KhdJyHyUckn93IBPwH-0JPkn5Gz6pTm91ly_LL_nndg';

  readonly style = 'normal.traffic.day';

  readonly url = `https://www.deutsche-alzheimer.de/osm/tile/{z}/{x}/{y}.png`;

  @Prop({ default: [] }) readonly markers!: MarkerResult[];

  @Prop({ default: null }) readonly coordinates!: {lat: number; lng: number} | null;

  mounted() {
    this.map = L.map('dalzg-leaflet', {
      center: [51.0, 10.5],
      zoom: 6,
      layers: [L.tileLayer(this.url)],
    });
    this.map.attributionControl.addAttribution('Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>');

    const component = this;
    L.easyButton('fa-globe', function(btn, map) {
      const latLng: any[] = [];
      component.addressMarkers.forEach((m) => {
        latLng.push(m.getLatLng());
      });
      if (component.coordinates !== null) {
        latLng.push(component.coordinates);
      }
      const bounds = new L.LatLngBounds(latLng);
      component.map.fitBounds(bounds, { maxZoom: 10});
    }, 'Zentrieren').addTo(this.map);
  }

  @Watch('coordinates', { deep: true })
  onCoordinatesChanged(newCoordinates: null | {lat: number, lng: number}) {
    if (this.circle !== null) {
      this.circle.removeFrom(this.map);
      this.circle = null;
    }

    if (newCoordinates !== null) {
      this.circle = new L.Circle(newCoordinates, {
        radius: 5000,
        color: '#e30915'
      });
      this.circle.addTo(this.map);
    }
  }

  @Watch('markers', { deep: true })
  onMarkersChange(newMarkers: MarkerResult[], oldMarkers: MarkerResult[]) {
    this.resetMarkers();
    const component = this;
    const latLng: any[] = [];

    newMarkers.forEach((marker) => {
      if (!this.addressClusters.hasOwnProperty(marker.category)) {
        this.addressClusters[marker.category] = L.markerClusterGroup({
          showCoverageOnHover: false,
          iconCreateFunction: (cluster) => {
            const childCount = cluster.getChildCount();
            const firstMarker = cluster.getAllChildMarkers()[0];
            const categoryId = (firstMarker as AddressMarker).category;
            const className = ` category-${categoryId}`;
            return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster' + className, iconSize: new L.Point(40, 40) });
          }
        });
      }

      const iconData = L.divIcon({
        iconSize: [36, 36],
        iconAnchor: [18, 36],
        className: `category-${marker.category}`,
        html: `
          <svg viewBox="0 0 24 24">
            <path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z" />
          </svg>
        `,
      });
      const newMarker = new AddressMarker({
        lat: parseFloat(marker.latitude),
        lng: parseFloat(marker.longitude),
      }, marker.uid, marker.category, marker.html, {icon: iconData});
      latLng.push([parseFloat(marker.latitude), parseFloat(marker.longitude)]);
      newMarker.bindPopup(marker.html);
      newMarker.on('click', function (event) {
        event.sourceTarget.openPopup();
      })
      
      component.addressClusters[marker.category].addLayer(newMarker);
      component.addressMarkers.push(newMarker);
    });

    if (component.coordinates !== null) {
      latLng.push(component.coordinates);
    }
    const bounds = new L.LatLngBounds(latLng);
    component.map.fitBounds(bounds, { maxZoom: 10 });
    // get current zoom
    const zoom = component.map.getZoom();

    for (const [_, value] of Object.entries(this.addressClusters)) {
      component.map.addLayer(value);
    }
    if (zoom < 7) {
      component.map.setZoom(7);
    }
  }

  resetMarkers() {
    const component = this;
    for (const [key, value] of Object.entries(this.addressClusters)) {
      component.map.removeLayer(value);
    }
    this.addressClusters = {};
    this.addressMarkers = [];
  }
}
